import React from "react";
import { ArrowRightIcon, CalendarIcon } from "lucide-react";
import type { CommunityEvent } from "../../types/content";
import { SiteLink } from "../SiteLink";
import { EventSummary } from "./EventSummary";
import { homeMedia } from "../../data/homeMedia";
type EventsSectionProps = {
  events: CommunityEvent[];
};
export function EventsSection({
  events
}: EventsSectionProps) {
  return <section aria-labelledby="events-title" className="bg-white" data-id="element-8" data-mp="3kde6dqt9o4ex">
      <div className="page-container py-16 md:py-24" data-id="element-9" data-mp="3kbkyk86x3e5c">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-10" data-mp="3fdt5haujdlzk">
          <div data-id="element-11" data-mp="3u2pdx90i910p">
            <h2 id="events-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-12" data-mp="3u2fphpv3z1x4">
              Michigan riding community
            </h2>
            <p className="mt-4 max-w-measure text-slate" data-id="element-13" data-mp="6z16njbq7v97">Motorcycle gatherings and community connections across Michigan.</p>
          </div>
          <SiteLink path="/events/" className="inline-flex min-h-[48px] w-fit items-center gap-2 text-label font-bold text-ink underline underline-offset-4 hover:text-crimson" data-id="element-14" data-mp="20zor1q1e1zb">
            See all events
            <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-15" data-mp="3789a6x1vg33u" />
          </SiteLink>
        </div>

        {events.length > 0 ? <div className="mt-8 divide-y divide-line border-y border-line" data-id="element-16" data-mp="3h55awglj3kxu">
            {events.map(event => <EventSummary key={event.id} event={event} data-id="element-17" data-mp="3l55zuv697ej5" />)}
          </div> : <div className="mt-8 flex flex-col gap-4 rounded-lg border border-line bg-ivory p-7 sm:flex-row sm:items-start md:p-9" data-id="element-18" data-mp="3q48v5nwfm6dx">
            <CalendarIcon aria-hidden="true" className="h-7 w-7 shrink-0 text-slate" data-id="element-19" data-mp="3uwsfd3pmjzrp" />
            <div data-id="element-20" data-mp="3p6aj7r65r99">
              <h3 className="text-h3 font-bold text-ink" data-id="element-21" data-mp="3rscmrvajek3">No upcoming events are listed right now</h3>
              <p className="mt-2 max-w-measure text-slate" data-id="element-22" data-mp="8mpoe6jyg20o">
                New Michigan motorcycle events appear on the events page when they are announced.
              </p>
            </div>
          </div>}

        <div className="mt-10 grid gap-6 border-t border-line pt-8 md:grid-cols-2 md:items-start md:gap-10" data-id="element-23" data-mp="24rxeeuma9jr1">
          <div data-id="element-24" data-mp="2ij3kj9k2ifmw">
            <p className="text-label font-bold text-crimson" data-id="element-25" data-mp="2ijlkag5xvbzk">Community archive</p>
            <h3 className="mt-3 text-h3 font-bold text-ink" data-id="element-26" data-mp="2dsvej1tlp74c">From Michigan’s riding community</h3>
            <p className="mt-4 max-w-measure text-slate" data-id="element-27" data-mp="2sh9jbiakv5nj">
              A look back at the 2019 Baldwin Blessing of the Bikes, shared in The Motorcycle Lawyer’s Facebook album.
            </p>
            <a href={homeMedia.community.sourceAlbum} target="_blank" rel="noopener noreferrer" className="mt-5 inline-flex min-h-[48px] items-center gap-2 text-label font-bold text-ink underline underline-offset-4 hover:text-crimson" data-id="element-28" data-mp="31hxxcczz160f">
              View the Facebook album
              <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-29" data-mp="1769gg5a6itde" />
              <span className="sr-only" data-id="element-30" data-mp="133wii31obzr6"> (opens in a new tab)</span>
            </a>
          </div>
          <figure className="mx-auto w-full max-w-[560px]" data-id="element-31" data-mp="szy36ihw3j13">
            <img src={homeMedia.community.src} width={homeMedia.community.width} height={homeMedia.community.height} alt={homeMedia.community.alt} data-media-id="baldwin-community-2019" loading="lazy" decoding="async" className="block aspect-[3/2] w-full rounded-lg border border-line object-cover object-[50%_35%]" data-id="element-32" data-mp="x0rnz301chpr" />
            <figcaption className="mt-3 text-meta text-slate" data-id="element-33" data-mp="ebbmodgj0l8a">Baldwin Blessing of the Bikes, 2019.</figcaption>
          </figure>
        </div>
      </div>
    </section>;
}